import React, { createContext, useCallback, useContext, useState } from 'react';
export const BreadcrumbContext = createContext(null);
export const useBreadcrumContext = () => {
    const context = useContext(BreadcrumbContext);
    if (!context) {
        throw new Error('useBreadcrumbContext must be used within the BreadcrumbProvider component');
    }
    return context;
};
const findBreadcrumbIndex = (breadcrumbs, breadcrumb) => {
    let index = breadcrumbs.findIndex(b => b === breadcrumb || b.path === breadcrumb.path);
    if (index === -1) {
        throw new Error(`Breadcrumb path not found: ${breadcrumb.path}`);
    }
    return index;
};
/**
 * Breadcrumb Context Provider initializes the breadcrumb array and sets up
 * the methods for setting breadcrumb items.
 * @param props
 */
export const BreadcrumbProvider = ({ label, path, initial = [], // default to empty array if not provided
children }) => {
    const [breadcrumbs, setBreadcrumbs] = useState(label ? [{ label, path }, ...initial] : initial);
    const addBreadcrumb = useCallback((breadcrumb) => {
        setBreadcrumbs(breadcrumbs => [...breadcrumbs, breadcrumb]);
    }, []);
    const updateBreadcrumb = useCallback((breadcrumb) => {
        setBreadcrumbs(breadcrumbs => {
            const index = findBreadcrumbIndex(breadcrumbs, breadcrumb);
            breadcrumbs[index] = breadcrumb;
            return [...breadcrumbs];
        });
    }, []);
    const removeBreadcrumb = useCallback((breadcrumb) => {
        setBreadcrumbs(breadcrumbs => {
            const index = findBreadcrumbIndex(breadcrumbs, breadcrumb);
            breadcrumbs.splice(index, 1);
            return [...breadcrumbs];
        });
    }, []);
    return (React.createElement(BreadcrumbContext.Provider, { value: {
            breadcrumbs,
            addBreadcrumb,
            updateBreadcrumb,
            removeBreadcrumb
        } }, children));
};
//# sourceMappingURL=BreadcrumbContext.js.map